import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n';

// ✅ All imports at the top
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { setLogLevel } from 'firebase/firestore';

// ✅ Register Firebase Messaging Service Worker only
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('✅ Firebase Messaging Service Worker registered:', registration.scope);
    })
    .catch((error) => {
      console.error('❌ Service Worker registration failed:', error);
    });
} else {
  console.warn('⚠️ Service Workers are not supported in this browser');
}

// ✅ Enable Firestore debug logs (optional)
setLogLevel('debug');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


